<template>
    <content class="boty" menu="成果简介"  :location = "['首页','成果简介']"> 
        <view class="main-body">
            <view class="main-content">
                <view class="data">
                    <view class="h1">成果简介</view>
                    <p>民族服饰产业是我国边疆地区富有特色的民族经济产业，是中华优秀传统文化创造性转化和创新性发展的重要依托产业，急需具有<b>家国情怀、创新实践能力</b>和<b>工匠精神</b>的民族服饰创新设计人才。</p>
                    <p>本成果坚持立德树人根本任务，深入落实全国教育大会精神和新文科育人理念，依托<b>教育部新文科研究与改革实践</b>项目，紧密联系区域经济发展，面向服务于内蒙古及我国边疆其他地区民族服饰产业的人才需求，以应用型人才培养为突破口，以提升学生实践、创新、服务和持续发展能力为目标，践行产出导向明确、与时俱进、持续改进的应用型人才培养模式改革创新，成效显著，服装与服饰设计专业入选<b>国家级“一流本科专业”建设点</b>。近10年的探索和实践，本成果形成直面边疆地区民族服饰产业需求的<b>“学研产创一体，政校企融通”</b>的<b>“三四四”</b>应用型人才培养模式。</p>
                    <p><b>“政校企融通”</b>即政府、高校、企业三方融通，协同培养应用型人才；<b>“学研产创一体”</b>为“专业与课程建设”“科研融入教学”“深化产教融合”“创新创业教育”四位一体，贯穿人才培养始终。<b>“三四四”人才培养模式：</b>“三”是指产教、校企、研创<b>“三联合”</b>；“四四”是指实践基地共建、双创育人体系共建、师资队伍共建、评价体系共建的<b>“四共建”</b>，和对接产品设计、对接企业生产、对接市场销售、对接社会服务的<b>“四对接”</b>，努力培养“重传承、厚基础、凸交叉、强实践”的高素质应用型人才。</p>
                    <p>成果始终服务边疆民族服饰产业发展，坚持<b>“深耕文化、守正创新”“校企协作、产学并进”“艺工融合、实践育人”“扎根边疆、服务区域”</b>的实践教学改革理念，努力构建应用型人才培养体系和互利共赢的政产学研协同育人机制。</p>
                </view>
            </view>
        </view>	
    </content>
</template>

<script>
    import content from '../content.vue'
	export default {
        components:{
            content,
        }
	}
</script>

<style lang="scss" scoped>

.data{
    margin-left: 20px;
    margin-bottom: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family:"FangSong";
    .h1{
        margin-top: 50px;
        margin-bottom: 20px;
        color: #333;
        font-size: 2ch;
        text-align: center;
        font-size: 3.2ch;
        font-weight: 900;
        
    }
    p{
        color: #333;
        font-weight: 550;
        line-height: 4ch;
        text-indent:30px;
        font-size: 2.4ch;
        margin:4px 0;
    }
    .image{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 30px 0;
        image{
            margin: 10px 0;
            text-align: center;
        }
        text{
            margin: 10px 0;
            color: #999;
            font-size: 1.6ch;
        }
    }
    
}

</style>
